<script>
export default {
    name: "ContractStatusChipComponent",
    props: {
        status: { type: Number, default: undefined },
    },
    computed: {
        chip() {
            if (!this.status) return { text: "Auftrag in Vorbereitung", color: "#ccc" };
            if (this.status == 1) return { text: "Auftrag in Arbeit", color: "info" };
            if (this.status == 2) return { text: "Auftrag geprüft", color: "accent" };
            if (this.status == 3) return { text: "Auftrag transportbereit", color: "success" };
            return { text: "Auftrag abgeschlossen", color: "error" };
        },
    },
};
</script>

<template>
    <v-chip small :color="chip.color">{{ chip.text }}</v-chip>
</template>
